type PackQuantityParams = {
  packQuantity: number;
  unitQuantity: number;
  quantityUnitInPack: number;
};
export const getPackQuantity = (params: PackQuantityParams): number => {
  return (
    params.packQuantity +
    (params.unitQuantity && params.quantityUnitInPack
      ? params.unitQuantity / params.quantityUnitInPack
      : 0)
  );
};

export const getQuantity = (drugList, translitName: string) => {
  const { packQuantity, unitQuantity, quantityUnitInPack } =
    drugList?.find((item) => item.drug?.translitName === translitName) || {};
  return { packQuantity, unitQuantity, quantityUnitInPack };
};

export const getStoreSummary = (pharmacyInfo) =>
  pharmacyInfo?.rests.reduce(
    (acc, item) => {
      const { packQuantity, unitQuantity, quantityUnitInPack } = getQuantity(
        pharmacyInfo.rests,
        item.drug.translitName
      );
      const quantity = getPackQuantity({
        quantityUnitInPack,
        packQuantity,
        unitQuantity
      });
      const newSum = {
        priceReserve: acc.priceReserve + item.priceReserve * quantity,
        discount: acc.discount + item.discount * quantity,
        priceWithoutDiscount: item?.priceWithoutDiscount
          ? acc.priceWithoutDiscount + item.priceWithoutDiscount * quantity
          : acc.priceWithoutDiscount
      };
      return newSum;
    },
    {
      priceReserve: 0,
      discount: 0,
      priceWithoutDiscount: 0
    }
  );

export const isNotInStock = (minPrice: number, foundInBranchesCount: number) =>
  minPrice === 0 || !minPrice || foundInBranchesCount === 0;
